import type { GalleryItem, GalleryCategory, Localized } from '../types'

export const galleryCategories: { id: GalleryCategory; label: Localized }[] = [
  { id: 'bathrooms', label: { en: 'Bathrooms', es: 'Baños' } },
  { id: 'kitchens', label: { en: 'Kitchens', es: 'Cocinas' } },
  { id: 'living', label: { en: 'Living Rooms', es: 'Salas' } },
]

export const galleryItems: GalleryItem[] = [
  {
    id: 'bath-1',
    category: 'bathrooms',
    title: { en: 'Master Bathroom', es: 'Baño Principal' },
    caption: {
      en: 'Hard water and soap scum removed from glass, tile and grout.',
      es: 'Sarro y jabón eliminados del vidrio, azulejo y juntas.',
    },
    before: 'https://cdn.magicpatterns.com/patterns/generated-images/dbc99171-129c-438a-97ce-bf58ea7ed310.jpg',
    after: 'https://cdn.magicpatterns.com/patterns/generated-images/44a554cf-9d1a-4f5a-970c-4ddbfe536add.jpg',
  },
  {
    id: 'kitchen-1',
    category: 'kitchens',
    title: { en: 'Kitchen Reset', es: 'Renovación de Cocina' },
    caption: {
      en: 'Counters cleared and polished, sink and appliances degreased.',
      es: 'Mesones despejados y pulidos, fregadero y electrodomésticos desengrasados.',
    },
    before: 'https://cdn.magicpatterns.com/patterns/generated-images/a9507bd0-832a-44b8-836c-7c3ad1953e51.jpg',
    after: 'https://cdn.magicpatterns.com/patterns/generated-images/85e12c09-a4fa-4c9a-94d8-e75482c892ce.jpg',
  },
  {
    id: 'living-1',
    category: 'living',
    title: { en: 'Living Room Refresh', es: 'Renovación de Sala' },
    caption: {
      en: 'Carpet vacuumed, surfaces dusted, windows cleaned inside.',
      es: 'Alfombra aspirada, superficies sin polvo y ventanas limpias.',
    },
    before: 'https://cdn.magicpatterns.com/patterns/generated-images/15fdafdd-69e1-45d5-bd04-f126cdc28f8c.jpg',
    after: 'https://cdn.magicpatterns.com/patterns/generated-images/559b5f72-4ff3-440a-abf4-0de8f9ed244b.jpg',
  },
  {
    id: 'bath-2',
    category: 'bathrooms',
    title: { en: 'Guest Bathroom Sanitizing', es: 'Desinfección de Baño de Visitas' },
    caption: {
      en: 'Full disinfection of toilet, sink, fixtures and floor tile.',
      es: 'Desinfección completa de inodoro, lavabo, llaves y piso.',
    },
    before: 'https://cdn.magicpatterns.com/patterns/generated-images/9c3d040e-33d7-4929-9c4d-53bdd06bb7fa.jpg',
    after: 'https://cdn.magicpatterns.com/patterns/generated-images/a179e74b-9d6c-4bf9-b761-a55b8a7c14bf.jpg',
  },
]
